<!--窗帘弹窗-->
<template>
	<div class="dimmingDialog">
		<el-dialog title="窗帘开关设置" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="设备状态" :label-width="formLabelWidth">
					<el-input v-model="form.state" autocomplete="off" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="高度设置" :label-width="formLabelWidth">
					<el-input v-model="form.curtaninHeight" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="config">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				dialogFormVisible:false,
				formLabelWidth:'120px',
				form:{
					state:'',
					curtaninHeight:'',
				},
				variable: '', //变量
				variableValue: '', //变量的值
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {
			dialogFormVisible(nv,ov){
				if(nv)
				this.$api.realApi.getMACRealValueWithID(this.variableValue, '', respon => {
					if(!isempty(respon)) {
						this.form.state = respon.data.split(':')[0] + ".00%"
					}
				})
			},
		},
		methods: {
			config(){
				var reg = new RegExp("^(\\d|[1-9]\\d|100)$");
				if(!reg.test(this.form.curtaninHeight)){
					this.$message.warning("请输入0带100数值")
					return
				}
				this.$api.lightOldApi.lightSinglewrite(this.variable, this.variableValue,this.form.curtaninHeight, respon => {
					this.$message({
						message:respon,
						type: 'success'
					});
					this.dialogFormVisible = false
				})
			}
		}
	}
</script>

<style>
	.dimmingDialog .el-dialog{
		width: 30%;
	}

</style>